module.exports = __webpack_public_path__ + "static/media/tormod.3db038bc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/tormod.svg
// module id = 297
// module chunks = 0